import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";

const TITLE = "Prijskaart — alle pakketten en prijzen | IT Solutions";
const DESC =
  "Overzicht van alle pakketten van IT Solutions: jaartarieven vanaf €749 en eenmalige trajecten vanaf €995. Download de volledige prijskaart als PDF.";

import { PrijskaartPage } from "@/pages/prijskaart";

export const Route = createFileRoute("/prijskaart")({
  head: () =>
    pageHead({ lang: "nl", pathWithoutLang: "/prijskaart", title: TITLE, description: DESC }),
  component: PrijskaartPage,
});
